import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { Menu } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  useAllPortfolios,
  useCurrentPortfolioId,
  useMaxAllowedPortfolios,
  useSideEditor,
} from "../../../store";
import { generatePortfolioColor } from "../../../utils";
import { PortfoliosButton } from "./PortfoliosButton/PortfoliosButton";
import {
  SAddIcon,
  SAddPortfolio,
  SContentCopyIcon,
  SGridContainer,
  SGridRow,
  SLabel,
  SMenuItem,
  SMenuTitle,
} from "./styles";

export const PortfoliosSelector: React.FC = () => {
  const { allPortfolios, createNewPortfolio } = useAllPortfolios();
  const [, setCurrentPortfolioId] = useCurrentPortfolioId();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isPortfoliosMaxedOut } = useMaxAllowedPortfolios();
  const [showCloneList, setShowCloneList] = useState(false);
  const { setPortfolioBeingEdited } = useSideEditor();

  const handleAddPortfolio = (): void => {
    if (!isPortfoliosMaxedOut()) {
      createNewPortfolio();
      setCurrentPortfolioId(Object.keys(allPortfolios).length);
      navigate("../", { replace: true });
    }
  };

  const handleCloneShowList = (): void => {
    setShowCloneList((isCloneListShown) => !isCloneListShown);
  };

  useEffect(() => {
    setPortfolioBeingEdited(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SGridContainer>
      <SGridRow>
        <SLabel>{t("portfoliosSelector.title")}</SLabel>
      </SGridRow>
      <SGridRow>
        {Object.keys(allPortfolios).map((portfolioKey) => {
          const portfolio = allPortfolios[Number(portfolioKey)];

          return (
            <PortfoliosButton
              text={portfolio.name}
              barColor={generatePortfolioColor(
                Number(portfolioKey),
                allPortfolios
              )}
              id={portfolioKey}
              key={portfolioKey}
            />
          );
        })}

        <PopupState variant="popover" popupId="demo-popup-menu">
          {(popupState) => (
            <>
              {/* eslint-disable react/jsx-props-no-spreading */}
              <SAddPortfolio
                $disabled={isPortfoliosMaxedOut()}
                disabled={isPortfoliosMaxedOut()}
                {...bindTrigger(popupState)}
              >
                {t("portfoliosSelector.add")}
              </SAddPortfolio>
              <Menu {...bindMenu(popupState)}>
                <SMenuTitle>
                  {t("portfoliosSelector.addPortfolio")}
                  <CloseIcon onClick={popupState.close} />
                </SMenuTitle>
                <SMenuItem onClick={handleAddPortfolio}>
                  <SAddIcon /> {t("portfoliosSelector.addPortfolio")}
                </SMenuItem>
                <SMenuItem onClick={handleCloneShowList}>
                  <SContentCopyIcon />
                  {t("portfoliosSelector.clonePortfolio")}
                </SMenuItem>
                {showCloneList && (
                  <SMenuItem onClick={handleCloneShowList}>
                    {Object.keys(allPortfolios).map((portfolioKey) => {
                      const portfolio = allPortfolios[Number(portfolioKey)];

                      return (
                        <PortfoliosButton
                          text={portfolio.name}
                          barColor={generatePortfolioColor(
                            Number(portfolioKey),
                            allPortfolios
                          )}
                          id={portfolioKey}
                          key={portfolioKey}
                          cloneMode={showCloneList}
                          cloneModeCloseMenu={popupState.close}
                        />
                      );
                    })}
                  </SMenuItem>
                )}
              </Menu>
            </>
          )}
        </PopupState>
      </SGridRow>
    </SGridContainer>
  );
};
